/**
 * Blog collection cards
 * Markup:
 *   <div class="wlk-collection-card" data-collection-handle="hanaoshoes-kyoyuzen">...</div>
 *
 * PC: 5 product images / SP: 3×2 = 6 product images
 * Title + 「もっと見る >」 link to the collection
 */
(function () {
  if (window.__wlkCollectionCardsInit) return;
  window.__wlkCollectionCardsInit = true;

  var PLACEHOLDER =
    'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
  var collectionsCache = null;

  function absUrl(pathOrUrl) {
    if (!pathOrUrl) return window.location.origin;
    if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;
    if (pathOrUrl.indexOf('//') === 0) return window.location.protocol + pathOrUrl;
    return window.location.origin + (pathOrUrl.charAt(0) === '/' ? pathOrUrl : '/' + pathOrUrl);
  }

  function productImage(product) {
    if (product.featured_image) {
      return typeof product.featured_image === 'string'
        ? product.featured_image
        : product.featured_image.src;
    }
    if (product.images && product.images.length) {
      return product.images[0].src || product.images[0];
    }
    return '';
  }

  function getCollections() {
    if (collectionsCache) return collectionsCache;
    collectionsCache = fetch('/collections.json?limit=250')
      .then(function (res) {
        if (!res.ok) throw new Error('collections.json failed');
        return res.json();
      })
      .then(function (data) {
        return data.collections || [];
      })
      .catch(function () {
        collectionsCache = null;
        return [];
      });
    return collectionsCache;
  }

  function findCollectionTitle(handle, collections) {
    for (var i = 0; i < collections.length; i++) {
      if (collections[i].handle === handle) return collections[i].title;
    }
    return '';
  }

  function fillCard(card, payload) {
    var handle = payload.handle;
    var title = payload.title;
    var products = payload.products || [];
    var collectionUrl = absUrl('/collections/' + handle);
    var label = card.getAttribute('data-btn-label') || 'もっと見る';
    var grid = card.querySelector('[data-role="grid"]');
    var titleLink = card.querySelector('[data-role="title-link"]');
    var btn = card.querySelector('[data-role="button"]');
    var btnLabel = card.querySelector('[data-role="btn-label"]');

    if (titleLink) {
      titleLink.textContent = title || handle;
      titleLink.href = collectionUrl;
    }
    if (btn) btn.href = collectionUrl;
    if (btnLabel) btnLabel.textContent = label;

    if (grid) {
      grid.innerHTML = '';
      var limit = 6;
      for (var i = 0; i < products.length && i < limit; i++) {
        var product = products[i];
        var href = absUrl(product.url || '/products/' + product.handle);
        var src = absUrl(productImage(product));
        var a = document.createElement('a');
        a.className = 'wlk-collection-card__item';
        a.href = href;
        a.setAttribute('data-role', 'item');

        var img = document.createElement('img');
        img.src = src || PLACEHOLDER;
        img.alt = product.title || '';
        img.width = 400;
        img.height = 400;
        img.loading = 'lazy';
        img.decoding = 'async';

        a.appendChild(img);
        grid.appendChild(a);
      }
    }

    card.classList.add('is-ready');
  }

  function loadCard(card) {
    var handle = (card.getAttribute('data-collection-handle') || '').trim();
    if (!handle || card.classList.contains('is-ready')) return;

    card.classList.add('is-loading');

    var productsUrl =
      '/collections/' + encodeURIComponent(handle) + '/products.json?limit=6';

    Promise.all([
      fetch(productsUrl).then(function (res) {
        if (!res.ok) throw new Error('products.json failed');
        return res.json();
      }),
      getCollections(),
    ])
      .then(function (results) {
        var productsData = results[0];
        var collections = results[1];
        var title =
          card.getAttribute('data-collection-title') ||
          findCollectionTitle(handle, collections) ||
          handle;

        fillCard(card, {
          handle: handle,
          title: title,
          products: productsData.products || [],
        });
        card.classList.remove('is-loading');
      })
      .catch(function () {
        card.classList.remove('is-loading');
        card.classList.add('is-error');
      });
  }

  function init() {
    document
      .querySelectorAll('.wlk-collection-card[data-collection-handle]')
      .forEach(loadCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
